var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "no-padding bg-white no-scroll full-height" },
    [
      _c(
        "q-card-main",
        { staticClass: "row full-height no-padding" },
        [
          _c(
            "div",
            { staticClass: "col-12 dash-number-box dash-number-box-padding" },
            [
              _c("h2", { staticClass: "dash-number-box__heading--bold" }, [
                _vm._v(_vm._s(_vm.$t("statistics_project_hours")))
              ]),
              _c("h3", { staticClass: "dash-number-box__sub-heading" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("statistics_project_hours_month")) +
                    "\n      "
                )
              ])
            ]
          ),
          _vm.hasData
            ? _c("project-seconds-statistics-donut-chart", {
                staticClass: "col-12 justify-center q-pa-lg",
                attrs: {
                  projectSecondsStatisticsData: _vm.data,
                  options: _vm.chartOptions,
                  height: 300
                }
              })
            : [
                _c("div", { staticClass: "col-12 text-center q-pb-lg" }, [
                  _c("span", { staticClass: "q-title text-blue-grey-4" }, [
                    _vm._v(_vm._s(_vm.$t("statistics_project_hours_no_data")))
                  ])
                ])
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }